const OSM_TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
const OSM_ATTRIBUTION = "&copy; OpenStreetMap contributors";

const NESHAN_CSS_URL =
  "https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.css";
const NESHAN_JS_URL =
  "https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.js";

let mapSdkLoadPromise = null;

export const loadMapSdk = () => {
  if (mapSdkLoadPromise) return mapSdkLoadPromise;

  mapSdkLoadPromise = new Promise((resolve, reject) => {
    if (window.L && window.L.Map && window.L.Map.prototype._neshanReady) {
      resolve(window.L);
      return;
    }

    if (!document.getElementById("neshan-sdk-css")) {
      const link = document.createElement("link");
      link.id = "neshan-sdk-css";
      link.rel = "stylesheet";
      link.href = NESHAN_CSS_URL;
      document.head.appendChild(link);
    }

    const existingScript = document.getElementById("neshan-sdk-js");
    if (existingScript) {
      if (existingScript.dataset.loaded === "true") {
        resolve(window.L);
      } else {
        existingScript.addEventListener("load", () => resolve(window.L));
        existingScript.addEventListener("error", reject);
      }
      return;
    }

    const script = document.createElement("script");
    script.id = "neshan-sdk-js";
    script.src = NESHAN_JS_URL;
    script.async = true;
    script.onload = () => {
      script.dataset.loaded = "true";
      resolve(window.L);
    };
    script.onerror = reject;
    document.body.appendChild(script);
  });

  return mapSdkLoadPromise;
};

export const createProviderMap = (
  L,
  container,
  { lat, lng, zoom = 13, provider = "osm", mapOptions = {} }
) => {
  if (provider === "neshan") {
    const apiKey = process.env.REACT_APP_NESHAN_MAP_API_KEY || process.env.VITE_NESHAN_MAP_API_KEY;
    return new L.Map(container, {
      key: apiKey,
      maptype: "dreamy",
      center: [lat, lng],
      zoom,
      attributionControl: false,
      ...mapOptions,
    });
  }

  const map = L.map(container, mapOptions).setView([lat, lng], zoom);
  L.tileLayer(OSM_TILE_URL, { attribution: OSM_ATTRIBUTION }).addTo(map);
  return map;
};